(() => {
  const DEBOUNCE_MS = 150;

  function getPredictiveUrl() {
    // Most Shopify themes set routes.predictive_search_url = "/search/suggest"
    if (window.routes && routes.predictive_search_url) return routes.predictive_search_url;
    return '/search/suggest';
  }

  function findPairs() {
    // We only wire inputs that have a results container in the same predictive-search wrapper
    const wrappers = document.querySelectorAll('predictive-search');
    const pairs = [];

    wrappers.forEach((wrap) => {
      const input = wrap.querySelector('input[type="search"][name="q"]');
      const results = wrap.querySelector('[data-predictive-search-results]');
      const status = wrap.querySelector('.predictive-search-status');

      if (input && results) pairs.push({ wrap, input, results, status });
    });

    return pairs;
  }

  function close(pair) {
    pair.wrap.removeAttribute('open');
    pair.input.setAttribute('aria-expanded', 'false');
    pair.results.innerHTML = '';
    pair.results.setAttribute('hidden', '');
  }

  function open(pair) {
    pair.wrap.setAttribute('open', 'true');
    pair.input.setAttribute('aria-expanded', 'true');
    pair.results.removeAttribute('hidden');
  }

  function setStatus(pair, text) {
    if (!pair.status) return;
    pair.status.setAttribute('aria-hidden', 'false');
    pair.status.textContent = text || '';
    setTimeout(() => pair.status && pair.status.setAttribute('aria-hidden', 'true'), 500);
  }

  async function fetchAndRender(pair, term) {
    const url = getPredictiveUrl();

    // Abort previous request for this input
    if (pair._abort) pair._abort.abort();
    pair._abort = new AbortController();

    setStatus(pair, pair.wrap.getAttribute('data-loading-text') || 'Loading…');

    try {
      const res = await fetch(
        `${url}?q=${encodeURIComponent(term)}&section_id=predictive-search`,
        { signal: pair._abort.signal }
      );

      if (!res.ok) throw new Error(String(res.status));
      const html = await res.text();

      const doc = new DOMParser().parseFromString(html, 'text/html');
      const section = doc.querySelector('#shopify-section-predictive-search');
      const markup = section ? section.innerHTML : '';

      // Render
      pair.results.innerHTML = markup;

      // If there is no markup, close
      if (!markup.trim()) {
        close(pair);
        return;
      }

      open(pair);

      // Live region count if present
      const countEl = pair.results.querySelector('[data-predictive-search-live-region-count-value]');
      if (countEl) setStatus(pair, countEl.textContent);

    } catch (e) {
      if (e?.name === 'AbortError') return;
      close(pair);
    }
  }

  function initPair(pair) {
    // Ensure hidden by default
    pair.results.setAttribute('hidden', '');
    pair.input.setAttribute('autocomplete', 'off');
    pair.input.setAttribute('aria-expanded', 'false');

    let t = null;

    pair.input.addEventListener('input', () => {
      const term = (pair.input.value || '').trim();

      if (t) clearTimeout(t);

      if (term.length < 2) {
        close(pair);
        return;
      }

      t = setTimeout(() => fetchAndRender(pair, term), DEBOUNCE_MS);
    });

    pair.input.addEventListener('focus', () => {
      const term = (pair.input.value || '').trim();
      if (term.length >= 2) fetchAndRender(pair, term);
    });

    // Close on click outside
    document.addEventListener('click', (ev) => {
      if (!pair.wrap.contains(ev.target)) close(pair);
    });
  }

  function boot() {
    const pairs = findPairs();
    pairs.forEach(initPair);

    // Helpful debug (you can remove later)
    console.log('[predictive-search-fix] wired pairs:', pairs.length, 'url:', getPredictiveUrl());
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
